import logger from "../logger/logger-init"
import CentraPath from "./CentraPath"
import { validateCentraLocaleShippingCountryCode } from "@/data/centra-locale-shipping-country-code"

const centraPath = new CentraPath(logger, validateCentraLocaleShippingCountryCode)

export default centraPath
